<template>
  <ODialog ref="dialog" :maxWidth="400" hideWhenLoading>
    <v-card v-if="counters != null">
      <ODialogBar title="Editar Contadores" @close="dismiss" />
      <v-card-text class="d-flex flex-column pa-6">
        <div class="d-flex gap-6 mb-6">
          <OTextField
            class="w-1/2"
            v-model.number="counters.horometer"
            suffix="horas"
            label="Horímetro"
          />

          <ODecimalInput
            class="w-1/2"
            v-model.number="counters.odometer"
            label="Odômetro"
            suffix="km"
          />
        </div>

        <div class="pa-0">
          <div
            class="amber lighten-2 rounded-lg d-flex pa-2 align-center space-between gap-4"
          >
            <div
              style="line-height: 32px"
              class="w-2 h-2 text-center grow-0 shrink-0"
            >
              <v-icon>mdi-alert</v-icon>
            </div>
            <div>
              Para evitar erros na telemetria, o horímetro e odômetro só devem
              ser alterados com o veículo desligado em uma área com bom sinal.
            </div>
          </div>
        </div>
      </v-card-text>
      <ODialogButtons
        class="pa-6"
        txtApply="Salvar e Embarcar"
        @apply="apply"
        @cancel="dismiss"
      />
    </v-card>
  </ODialog>
</template>

<script>
import { OrgApi } from '@/models'
import ODecimalInput from 'oderon-vue/cpts/ODecimalInput.vue'

export default {
  components: { ODecimalInput },
  data() {
    return { counters: null }
  },
  methods: {
    open(vehicle) {
      this.vehicle = vehicle
      this.$refs.dialog.$loading(() => this.fetchData())
      return this.$refs.dialog.$open()
    },
    async fetchData() {
      let fetcher = new OrgApi(this.vehicle.orgId)
      let res = await fetcher.get(`vehicles/${this.vehicle.idInOrg}`)

      // Horímetro em número inteiro de horas apenas
      let horometer = Math.floor((res.horometer || 0) / 3600)

      // Odômetro com 2 casas decimais
      let odometer = Math.floor((res.odometer || 0) / 10) / 100

      this.counters = { horometer, odometer }
    },
    dismiss() {
      this.$refs.dialog.$dismiss()
    },
    apply() {
      this.$refs.dialog.$loading(async () => {
        let body = {
          horometer: this.counters.horometer * 3600,
          odometer: this.counters.odometer * 1000
        }

        let fetcher = new OrgApi(this.vehicle.orgId)
        await fetcher.put(`vehicles/${this.vehicle.idInOrg}/counters`, body)

        this.$snack('Salvo com sucesso')
        return this.$refs.dialog.$apply(true)
      })
    }
  }
}
</script>

<style></style>
